import { ApplicationConfig, provideBrowserGlobalErrorListeners, provideZoneChangeDetection } from '@angular/core';
import { NavigationError, provideRouter, withComponentInputBinding, withNavigationErrorHandler } from '@angular/router';
import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';

import { routes } from './app.routes';
import { authInterceptor } from './services/callApi/Auth.interceptor';

/** Clé du dernier rechargement après une nouvelle version : évite de boucler si le fichier manque vraiment. */
const RELOAD_KEY = 'pkg_admin_chunk_reload_at';

/**
 * Après un déploiement, un onglet resté ouvert réclame les morceaux de code de l'ancienne version, qui
 * n'existent plus sur le serveur : la navigation échoue et le menu semble bloqué. On recharge alors la
 * page demandée, une fois par minute au plus, pour repartir sur la nouvelle version.
 */
function reloadOnStaleChunk(error: NavigationError): void {
  const message = String((error.error as Error | undefined)?.message ?? error.error ?? '');
  if (!/dynamically imported module|Importing a module script failed|error loading dynamically imported module|ChunkLoadError/i.test(message)) return;
  try {
    const last = Number(sessionStorage.getItem(RELOAD_KEY) || 0);
    if (Date.now() - last < 60_000) return;
    sessionStorage.setItem(RELOAD_KEY, String(Date.now()));
  } catch {
    /* stockage indisponible : on recharge quand même, une boucle reste peu probable */
  }
  window.location.assign(error.url);
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes, withComponentInputBinding(), withNavigationErrorHandler(reloadOnStaleChunk)),
    provideHttpClient(withFetch(), withInterceptors([authInterceptor]))
  ]
};
